import RequiredValidator from "@/validators/RequiredValidator";

export default class AvatarRules {

	public static readonly fileRules = [
		(new RequiredValidator('ui.terms.selectImageFile')).validationRule(),
	];

}
